import SortIcon from "../../../global/components/SortIcon";
import { hasRole } from "../../../global/hooks/getUserRole";

export const DeviceColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  columnsValues
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};
  const isColumnVisible = (columnKey) => {
    return columnsValues?.includes(columnKey);
  };

  const createSortableColumn = (
    title,
    dataIndex,
    columnKey = dataIndex,
    sortKey,
    icon = true,
    hidden,
    width
  ) => ({
    title,
    dataIndex,
    key: columnKey,
    width: width,
    sorter: (a, b) => () => {},
    hidden: hidden,
    render: (text, record) => {
      return title === "Dealer" ? (record?.Dealer ? text : "Guest") : text;
    },
    // sorter: (a, b) =>
    //   (a?.[dataIndex]?.length || 0) - (b?.[dataIndex]?.length || 0),
    sortIcon: () =>
      icon ? (
        <SortIcon
          sortOrder={modParams.order}
          columnKey={sortKey}
          sortBy={modParams.sort_by}
        />
      ) : null,
    onHeaderCell: () => ({
      onClick: () =>
        setParams({
          ...modParams,
          sort_by: sortKey,
          order: modParams.order === "desc" ? "asc" : "desc",
        }),
    }),
  });

  const columns = [
    createSortableColumn(
      "No",
      "DeviceNo",
      "DeviceNo",
      "DeviceNo",
      true,
      !isColumnVisible("DeviceNo"),
      80
    ),
    createSortableColumn(
      "Device Name",
      "DeviceName",
      "DeviceName",
      "DeviceName",
      true,
      !isColumnVisible("DeviceName"),
      150
    ),
    createSortableColumn(
      "Description",
      "DeviceDesc",
      "DeviceDesc",
      "DeviceDesc",
      true,
      !isColumnVisible("DeviceDesc"),
      150
    ),
    // ...(hasRole(1, 2, 3)
    //   ? [
    //       createSortableColumn(
    //         "Production",
    //         "Production",
    //         "Production",
    //         "ProductionNo"
    //       ),
    //     ]
    //   : []),
    ...(hasRole(1, 2, 3)
      ? [
          createSortableColumn(
            "OEM",
            "Oem",
            "Oem",
            "OemNo",
            true,
            !isColumnVisible("Oem"),
            160
          ),
        ]
      : []),
    ...(hasRole(1, 2, 3, 4, 5, 6)
      ? [
          createSortableColumn(
            "Dealer",
            "Dealer",
            "Dealer",
            "DealerNo",
            true,
            !isColumnVisible("Dealer"),
            150
          ),
        ]
      : []),
    createSortableColumn(
      "Customer",
      "Customer",
      "Customer",
      "CustomerNo",
      true,
      !isColumnVisible("Customer"),
      150
    ),
    createSortableColumn(
      "Node Type",
      "NodeType",
      "NodeType",
      "NodeType",
      true,
      !isColumnVisible("NodeType"),
      120
    ),
    createSortableColumn(
      "Site Type",
      "SiteType",
      "SiteType",
      "SiteType",
      true,
      !isColumnVisible("SiteType"),
      120
    ),
    createSortableColumn(
      "MAC",
      "Mac",
      "Mac",
      "Mac",
      true,
      !isColumnVisible("Mac"),
      150
    ),
    createSortableColumn(
      "Product",
      "Product",
      "Product",
      "Product",
      true,
      !isColumnVisible("Product"),
      120
    ),
    createSortableColumn(
      "Model",
      "Model",
      "Model",
      "Model",
      true,
      !isColumnVisible("Model"),
      120
    ),
    createSortableColumn(
      "Door",
      "Type",
      "Type",
      "Type",
      true,
      !isColumnVisible("Type"),
      120
    ),
    createSortableColumn("", "", "", "", false, false, 10),
  ];

  return columns;
};
